<template>
    <div class="ruleAlert">
        <div class="box">
            <div class="content">
                <div class="title">积分抵现规则</div>
                <div class="item">
                    1、活动期间,租车可享用积分直接抵扣租金,{{exchangeRate}}分抵扣1元，{{minScore}}分起参加抵现，单次最高可抵扣{{maxScore}}积分。
                </div>
                <div class="item">
                    2、积分仅可抵扣车辆日租金，基本保障服务费、车辆整备费正常收取。
                </div>
                <div class="item">
                    3、积分抵现仅适用于短租自驾订单。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ruleAlert",
  data(){
    return {
      exchangeRate: '',
      minScore: '',
      maxScore: ''
    }
  },
  created() {
    let _query = this.$route.query;
    console.log(_query);
    this.exchangeRate = _query.exchangeRate || '';
    this.minScore = _query.minScore || '';
    this.maxScore = _query.maxScore || '';
  }
}
</script>

<style lang="scss" scoped>
    .ruleAlert {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .box {
            position: relative;
            z-index: 1000;
            width: 100%;
            background-color: #fff;
            .content {
                padding: 30px;
                box-sizing: border-box;
                .item {
                    margin-top: 20px;
                    color: #5e5e5e;
                }
                .title {
                    display: flex;
                    justify-content: center;
                    font-size: 32px;
                }
            }
            .button {
                display: flex;
                justify-content: center;
                padding: 30px 0;
                font-size: 32px;
                color: #ff6600;
                border-top: solid 1px #e2e2e2; /*no*/
            }
        }
    }
</style>